/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore.js';

import Loading from 'components/Loading/Loading';

import ActionDrawerHeader from '../../../components/ActionDrawerHeader/ActionDrawerHeader';
import ArchiveProjectForm from './ArchiveProjectForm/ArchiveProjectForm';
import ArchiveProjectSuccess from './ArchiveProjectSuccess/ArchiveProjectSuccess';
import ArchiveProjectError from './ArchiveProjectError/ArchiveProjectError';
import Form from '../../../../../forms/_.extend';

import styles from '../../../ActionDrawer.module.scss';

type TypeProps = {|
  formData: Object,
  actionDrawerStore: TypeActionDrawerStore,
|} & TranslatorProps;

@translate()
@inject('actionDrawerStore')
@observer
export default class ArchiveProject extends React.Component<*> {
  createForm = () => {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;
    const fields: Array<Object> = [
      {
        name: 'archiveProjectForm',
        label: t('general:actions.archive_project'),
        title: 'Archive Project',
        fields: [
          {
            name: 'reason',
            label: t('general:reasons.reason_for_archiving_project'),
            rules: 'required|string',
            value: '',
            type: 'select',
            options: [
              {
                id: 1,
                label: t('general:reasons.options.project_complete'),
              },
              {
                id: 'other',
                label: t('general:reasons.options.other'),
              },
            ],
          },
        ],
      },
    ];

    const hooks: Object = {
      onSuccess(data: Object) {
        const {
          reason,
        }: //reason text
        Object = data.values().archiveProjectForm;

        actionDrawerStore.archiveProject(project.id, {
          activity_reason: reason,
        });
      },
    };

    return new Form(
      { fields },
      {
        hooks,
        options: {
          validateOnInit: true,
          validateOnChange: true,
        },
        name: t('general:actions.archive_project'),
      }
    );
  };

  render(): React.Element<*> {
    const { t }: TranslatorProps = this.props;
    const { actionDrawerStore }: TypeProps = this.props;
    const project: Object = this.props.project;

    if (actionDrawerStore.loading) {
      return <Loading />;
    }

    if (actionDrawerStore.error) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.error}`}>
          <ActionDrawerHeader title={t('general:actions.archive_project')} />
          <ArchiveProjectError project={project} response={actionDrawerStore.response} />
        </div>
      );
    }

    if (actionDrawerStore.success) {
      return (
        <div className={`${styles['action-drawer-form']} ${styles.success}`}>
          <ActionDrawerHeader title={t('general:actions.archive_project')} />
          <ArchiveProjectSuccess response={actionDrawerStore.response} />
        </div>
      );
    }

    return (
      <div className={styles['action-drawer-form']}>
        <ActionDrawerHeader title={t('general:actions.archive_project')} />
        <ArchiveProjectForm project={project} form={this.createForm()} />
      </div>
    );
  }
}
